import { COLORS } from '../constants';
const LOAD_IMAGE_TIMEOUT = 10000;
export const HOOK = `data-shape-id`;
export const radiansToDegrees = (radians = 0) => {
    const degrees = radians * (180 / Math.PI);
    return degrees > 180 ? degrees - 360 : degrees;
};
export const degreesToRadians = (degrees = 0) => ((degrees % 360) * Math.PI) / 180;
export const reverseDegrees = (degrees) => 360 - degrees;
export const getElementHookValue = (id, idPostfix = '') => {
    const postfix = idPostfix ? `-${idPostfix}` : '';
    return `${id}${postfix}`;
};
export const getElementQuery = (id, idPostfix) => {
    const attributeValue = getElementHookValue(id, idPostfix);
    return `[${HOOK}="${attributeValue}"]`;
};
export const round = (value, precision = 0.01) => Math.round(value / precision) * precision;
export const floor = (value, precision = 0.01) => Math.floor(value / precision) * precision;
export const ceil = (value, precision = 0.01) => Math.ceil(value / precision) * precision;
export const getElement = (id, svgContainer, idPostfix) => {
    const existentElement = svgContainer.querySelector(getElementQuery(id, idPostfix));
    if (existentElement) {
        return existentElement;
    }
    return null;
};
export const getSvgSrc = (element, sourceFormatter = source => source) => {
    if (!element) {
        return null;
    }
    else {
        return 'data:image/svg+xml,' + encodeURIComponent(sourceFormatter(element.innerHTML));
    }
};
export var SnapshotFormat;
(function (SnapshotFormat) {
    SnapshotFormat["SVG"] = "image/svg";
    SnapshotFormat["PNG"] = "image/png";
    SnapshotFormat["JPG"] = "image/jpeg";
    SnapshotFormat["WEBP"] = "image/webp";
})(SnapshotFormat || (SnapshotFormat = {}));
export const snapshotDom = async ({ container, dimensions = {}, format = SnapshotFormat.PNG, sourceFormatter = source => source, quality = 1, backgroundColor, }) => {
    let { input, output } = dimensions !== null && dimensions !== void 0 ? dimensions : {};
    if (!input) {
        input = container.getBoundingClientRect();
    }
    if (!output) {
        output = input;
    }
    const svgFormatString = 'data:image/svg+xml;charset=utf-8,';
    const { width: inputWidth, height: inputHeight } = input;
    const start = `<svg xmlns="http://www.w3.org/2000/svg" width="${inputWidth}" height="${inputHeight}">
      <style scoped="">
        html::-webkit-scrollbar {
          display: none;
        }

        html, body {
          margin: 0;
        }

        svg {
          overflow: visible;
        }
      </style>
      <foreignObject x="0" y="0" width="${inputWidth}" height="${inputHeight}" style="float: left;" externalResourcesRequired="true">
        <html xmlns="http://www.w3.org/1999/xhtml">
          <head/>
          <body>
  `;
    const end = `
          </body>
        </html>
      </foreignObject>
    </svg>
  `;
    let source = start + sourceFormatter(container.innerHTML) + end;
    source = source.replace(/&nbsp;/g, '&#160;');
    const svgSrc = svgFormatString + encodeURIComponent(source);
    if (format === SnapshotFormat.SVG) {
        return svgSrc;
    }
    // Convert to image
    const { width: outputWidth, height: outputHeight } = output;
    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    const ctx = canvas.getContext('2d');
    if (format === SnapshotFormat.JPG) {
        ctx.fillStyle = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : COLORS.DEFAULT_BACKGROUND;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    const image = document.createElement('img');
    await new Promise((resolve, reject) => {
        const loadImageTimeout = setTimeout(() => {
            reject(new Error('SVG image generation timed out'));
        }, LOAD_IMAGE_TIMEOUT);
        image.onload = () => {
            clearTimeout(loadImageTimeout);
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            resolve(null);
        };
        image.src = svgSrc;
    });
    let src = '';
    await new Promise(resolve => {
        canvas.toBlob(blob => {
            const reader = new FileReader();
            reader.onloadend = () => {
                src = reader.result;
                resolve(null);
            };
            reader.readAsDataURL(blob);
        }, format, quality);
    });
    return src;
};
export const unique = (values) => Array.from(new Set(values));
//# sourceMappingURL=utils.js.map